import { Container, Image } from 'react-bootstrap'

const WhyCarbs = () => (
    <>
    <div className="section-why-carbs text-center">
        <Container>
            <p className="mb-5">Learn why carbs are ok <br className="d-lg-none d-block"/>
                <small>and which ones to choose</small></p>
            <Image src="../images/7bs/img-carbs01.jpg" alt="Learn Why Carbs Are Ok" className="img-fluid d-block mx-auto"/>
        </Container>
    </div>
    <style jsx global>{`

            .section-why-carbs {
                background: #EEE9E3;
            }

            .section-why-carbs .container {
                padding-top: 90px;
                padding-bottom: 70px;
            }

            .section-why-carbs p {
                color: #de7621;
                font-size: 40px;
                line-height: 48px;
            }

            .section-why-carbs small {
                color: #212529;
            }

            @media (max-width: 767.98px) {

                .section-why-carbs .container {
                    padding-top: 35px;
                    padding-bottom: 25px;
                }

                .section-why-carbs p {
                    font-size: 30px;
                    line-height: 38px;
                }

            }

        `}</style>
    </>
);

export default WhyCarbs;